import "./src/lib/sentry";
import "react-native-url-polyfill/auto";
import "expo-router/entry";
import { Platform } from "react-native";
import { setupWidgetTaskHandler } from "~/features/widget/widget-task-handler";
import { setupWidgetConfigurationScreen } from "~/features/widget/WidgetConfigurationScreen";

// Android home-screen widget registrations. Skipped on web: react-native-web's
// AppRegistry has no registerHeadlessTask, so the task handler threw
// "registerHeadlessTask is not a function" on every page load (and Sentry
// captured it).
if (Platform.OS !== "web") {
  setupWidgetTaskHandler();
  setupWidgetConfigurationScreen();
}
